import { formatUIDate } from 'utils/helpers'
import { AccompanyingNotePayloadItem } from '../interfaces'

export const toTableRowItems = (items: AccompanyingNotePayloadItem[]) =>
  items.map(item => ({
    id: item.id,
    wanNumber: item.wanNumber ?? '',
    storeName: item.storeName ?? '',
    creationDate: formatUIDate(item.date),
    wasteCategories: item.wasteCategories
      ? item.wasteCategories.map((category: string) => ({ name: category }))
      : [],
    companyName: item.companyName ?? '',
    wasteReports: item.linkedReports
      ? item.linkedReports.map(wasteReport => ({
          report: wasteReport
        }))
      : [],
    measuredWeight: item.measuredWeight ?? '',
    documentNo: item.documentNo ?? 0,
    totalArticles: item.totalArticles ?? 0,
    totalCalculatedWeight: item.totalCalculatedWeight ?? 0
  }))
